import "./index.scss";
// import { $ } from "@olmokit/dom";

/**
 * Component: BorderTop
 */
export function BorderTop() {
  console.log("BorderTop mounted.");
}
